import type { ImpressionType } from '@/ImpressionType'

export const impressionDataAutre5minutes: ImpressionType = {
  title: 'Autre 5 minutes.',
  impressionContent: `
<p>
Écrire c'est se perdre aussi,<br/>
Dans un émoi, dans un minois,<br/>
En soi, un soir, sans phare.<br/>
<br/>
</p>

<p>
Est-ce guérir que d'écrire ?<br/>
Revenir, traîner, dans les limbes de notre passé.<br/>
<br/>
</p>


<p>
C'est aussi l'ironie, toi, de te veiller,<br/>
Endormie, dans ton dernier lit.<br/>
Tes mains glacées, une vie qui t'a quittée.<br/>
Poussé au dehors,<br/>
Toi, qui fut tant gâté.<br/>
<br/>
</p>

<p>
Je reste avec toi,<br/>
Une intimité que nous n'avons jamais eue.<br/>
5 minutes.<br/>
Toi et moi.<br/>
<br/>
</p>

<p>
Te prendre la main, glacé,<br/>
Sentir des muscles sans vie,<br/>
Te tenir, te parler, t'embrasser.<br/>
De ton vivant nous ne l'avons que rarement fait.<br/>
<br/>
</p>

<p>
C'est un océan d'émotions, sans direction,<br/>
Comme ses vagues, croisées, qui nous accompagnaient les étés de notre enfance.<br/>
Insouciance...<br/>
<br/>
</p>

<p>
5 minutes,<br/>
D'émotions a vous tordre la gorge, le cou.<br/>
Des spasmes, des torsions, des contraintes.. mécanique de chair.<br/>
<br/>
</p>

<p>
C'est te voir si près, nous qui étions si loin.<br/>
C'est cette odeur, mêlée à ce froid.<br/>
L'odeur de la mort, le poids de la douleur.<br/>
Les pleurs des parents, des enfants.<br/>
Les miens, et toi belle impassible.<br/>
<br/>
</p>

<p>
C'est 5 minutes,<br/>
Tu ne les vivras pas.<br/>
Tu n'en voulais plus.<br/>
Tu me laisses avec.<br/>
Tu nous laisses ainsi.<br/>
<br/>
</p>

<p>
Si tu voyais nos douleurs...<br/>
<br/>
</p>

<p>
Que tu es conne ma sœur.<br/>
<br/>
</p>
 `,
  illustrationCaption: 'Moins de distance...',
  illustrationCopyright: 'Source: openai',
  illustrationPath: '/img/impressions/autre-5-minutes-1.jpg',
  noteEntries: [
    'Un an après..'
  ]
}
